import { createFileRoute } from "@tanstack/react-router";
import { IntegrationsPage } from "@/components/integrations/IntegrationsPage";

// The destinations list, moved here unchanged from `integrations.tsx`'s old
// direct component when that became a layout route.
export const Route = createFileRoute("/dashboard/w/$workspaceId/integrations/")({
  component: Integrations,
});

function Integrations() {
  const { workspaceId } = Route.useParams();
  return <IntegrationsPage workspaceId={workspaceId} />;
}
